import {
  faBook,
  faCartShopping,
  faChartLine,
  faClover,
  faCommentDots,
  faGift,
  faHeadphones,
  faHeadset,
  faMoneyBillTransfer,
  faUser,
  faUsers,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { faComments } from '@fortawesome/free-solid-svg-icons';

export interface IMenu {
  menu: string;
  link?: string;
  sid?: string;
  icon?: ReactElement;
  children?: IMenu[];
}

export const userMenuList: IMenu[] = [
  {
    menu: '주문',
    icon: <FontAwesomeIcon icon={faCartShopping} />,
    children: [
      {
        menu: '주문 등록',
        link: '/order/create',
      },
      {
        menu: '단건 주문',
        link: '/order/single',
      },
      {
        menu: '주문 대기',
        link: '/order/list',
      },
      {
        menu: '주문 확정',
        link: '/order/fix',
      },
    ],
  },
  {
    menu: '상담 주문',
    icon: <FontAwesomeIcon icon={faHeadset} />,
    children: [
      {
        menu: '정보 입력',
        link: '/consult-order/create',
      },
      {
        menu: '정보 확정',
        link: '/consult-order/list',
      },
      {
        menu: '정보 확인',
        link: '/consult-order/fix',
      },
    ],
  },
  {
    menu: '랜딩 페이지',
    icon: <FontAwesomeIcon icon={faBook} />,
    children: [
      {
        menu: '상담 랜딩페이지',
        link: '/randing/compain',
      },
      {
        menu: '상담 신청내역',
        link: '/randing/request',
      },
      {
        menu: '구매 랜딩페이지',
        link: '/purchase-landing/management',
      },
      {
        menu: '구매 신청내역',
        link: '/purchase-landing/request',
      },
    ],
  },
  // {
  //   menu: 'CS',
  //   link: '/cs',
  //   icon: <FontAwesomeIcon icon={faHeadphones} />,
  // },
  {
    menu: '상품',
    link: '/product',
    icon: <FontAwesomeIcon icon={faGift} />,
  },
  {
    menu: '복비',
    icon: <FontAwesomeIcon icon={faMoneyBillTransfer} />,
    children: [
      {
        menu: '복비 내역',
        link: '/bokbi/bokbi-history',
      },
      {
        menu: '복비 통계',
        link: '/bokbi/bokbi-statistics',
      },
      {
        menu: '복비 입금 신청',
        link: '/bokbi/purchase',
      },
      {
        menu: '입금 대기 관리',
        link: '/bokbi/purchase-order',
      },
    ],
  },
  {
    menu: '카카오 채널 연동',
    link: '/bizmsg/sender',
    icon: <FontAwesomeIcon icon={faComments} />,
  },
  {
    menu: '오늘의 운세',
    icon: <FontAwesomeIcon icon={faClover} />,
    children: [
      {
        menu: '캠페인 생성/조회',
        link: '/today-saju/codes',
      },
      {
        menu: '신청 내역 조회',
        link: '/today-saju/performance',
      },
      {
        menu: '쿠폰 발송',
        link: '/today-saju/coupon-send',
      },
    ],
  },
  {
    menu: '내 정보',
    icon: <FontAwesomeIcon icon={faUser} />,
    children: [
      {
        menu: '프로필',
        link: '/mypage/profile',
      }
    ],
  },
  {
    menu: '이메일 템플릿',
    link: '/email-template',
    icon: <FontAwesomeIcon icon={faEnvelope} />,
  },
  {
    menu: '카톡으로 문의하기',
    link: 'http://pf.kakao.com/_dxmxhjn/chat',
    icon: <FontAwesomeIcon icon={faComments} />,
  },
];

export const csMenuList: IMenu[] = [
  {
    menu: '주문',
    icon: <FontAwesomeIcon icon={faCartShopping} />,
    children: [
      {
        menu: '주문 등록',
        link: '/order/create',
      },
      {
        menu: '단건 주문',
        link: '/order/single',
      },
      {
        menu: '주문 대기',
        link: '/order/list',
      },
      {
        menu: '주문 확정',
        link: '/order/fix',
      },
    ],
  },
  {
    menu: '상담 주문',
    icon: <FontAwesomeIcon icon={faHeadset} />,
    children: [
      {
        menu: '정보 입력',
        link: '/consult-order/create',
      },
      {
        menu: '정보 확정',
        link: '/consult-order/list',
      },
      {
        menu: '정보 확인',
        link: '/consult-order/fix',
      },
    ],
  },
  {
    menu: '랜딩 페이지',
    icon: <FontAwesomeIcon icon={faBook} />,
    children: [
      {
        menu: '상담 랜딩페이지',
        link: '/randing/compain',
      },
      {
        menu: '상담 신청내역',
        link: '/randing/request',
      },
      {
        menu: '구매 랜딩페이지',
        link: '/purchase-landing/management',
      },
      {
        menu: '구매 신청내역',
        link: '/purchase-landing/request',
      },
    ],
  },
];

export const adminMenuList: IMenu[] = [
  {
    menu: '주문',
    icon: <FontAwesomeIcon icon={faCartShopping} />,
    children: [
      {
        menu: '주문 등록',
        link: '/order/create',
      },
      {
        menu: '단건 주문',
        link: '/order/single',
      },
      {
        menu: '주문 대기',
        link: '/order/list',
      },
      {
        menu: '주문 확정',
        link: '/order/fix',
      },
    ],
  },
  {
    menu: '상담 주문',
    icon: <FontAwesomeIcon icon={faHeadset} />,
    children: [
      {
        menu: '정보 입력',
        link: '/consult-order/create',
      },
      {
        menu: '정보 확정',
        link: '/consult-order/list',
      },
      {
        menu: '정보 확인',
        link: '/consult-order/fix',
      },
    ],
  },
  {
    menu: '랜딩 페이지',
    icon: <FontAwesomeIcon icon={faBook} />,
    children: [
      {
        menu: '상담 랜딩페이지',
        link: '/randing/compain',
      },
      {
        menu: '상담 신청내역',
        link: '/randing/request',
      },
      {
        menu: '구매 랜딩페이지',
        link: '/purchase-landing/management',
      },
      {
        menu: '구매 신청내역',
        link: '/purchase-landing/request',
      },
    ],
  },
  // {
  //   menu: 'CS',
  //   link: '/cs',
  //   icon: <FontAwesomeIcon icon={faHeadphones} />,
  // },
  {
    menu: '프롬프트',
    link: '/prompt',
    icon: <FontAwesomeIcon icon={faCommentDots} />,
  },
  {
    menu: '상품',
    icon: <FontAwesomeIcon icon={faGift} />,
    children: [
      {
        menu: '상품 목록',
        link: '/product/list',
      },
      {
        menu: '상품 확인',
        link: '/product/thumbnail',
      },
    ],
  },
  {
    menu: '통계',
    icon: <FontAwesomeIcon icon={faChartLine} />,
    children: [
      { menu: '가맹점별 통계', link: '/statistics/franchise' },
      { menu: '상품별 통계', link: '/statistics/product' },
    ]
  },
  {
    menu: '가맹점',
    link: '/franchise',
    icon: <FontAwesomeIcon icon={faUsers} />,
  },
  {
    menu: '오늘의 운세',
    icon: <FontAwesomeIcon icon={faClover} />,
    children: [
      {
        menu: '캠페인 생성/조회',
        link: '/today-saju/codes',
      },
      {
        menu: '신청 내역 조회',
        link: '/today-saju/performance',
      },
      {
        menu: '쿠폰 발송',
        link: '/today-saju/coupon-send',
      },
    ],
  },
  {
    menu: '복비',
    icon: <FontAwesomeIcon icon={faMoneyBillTransfer} />,
    children: [
      {
        menu: '복비 내역',
        link: '/bokbi/bokbi-history',
      },
      {
        menu: '복비 통계',
        link: '/bokbi/bokbi-statistics',
      },
      {
        menu: '복비 입금 신청',
        link: '/bokbi/purchase',
      },
      {
        menu: '입금 대기 관리',
        link: '/bokbi/purchase-order',
      },
    ],
  },
  {
    menu: '이메일 템플릿',
    link: '/email-template',
    icon: <FontAwesomeIcon icon={faEnvelope} />,
  },
  {
    menu: '카톡으로 문의하기',
    link: 'http://pf.kakao.com/_dxmxhjn/chat',
    icon: <FontAwesomeIcon icon={faComments} />,
  },
];

export const trackingMenuList: IMenu[] = [
  {
    menu: '오늘의 운세',
    icon: <FontAwesomeIcon icon={faClover} />,
    children: [
      {
        menu: '캠페인 생성/조회',
        link: '/today-saju/codes',
      },
      {
        menu: '신청 내역 조회',
        link: '/today-saju/performance',
      },
      {
        menu: '쿠폰 발송',
        link: '/today-saju/coupon-send',
      },
    ],
  },
];

export const joinedMenuList: IMenu[] = [];
